
import React from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { Link } from 'react-router-dom';

const SpecialOfferEndedModal = () => {
  return (
    <Dialog open={true}>
      <DialogContent className="max-w-md mx-auto p-8 text-center" hideCloseButton>
        {/* AskSpot Logo */}
        <div className="mb-6">
          <img 
            src="/lovable-uploads/6df08ee1-fcec-4fbf-a51d-3e01ada7cdb8.png" 
            alt="AskSpot Logo" 
            className="max-w-full h-auto mx-auto max-h-[120px] rounded-lg"
          />
        </div>
        
        {/* Message */}
        <h2 className="text-2xl font-bold text-[#003a70] mb-6">
          This Special Offer Has Ended
        </h2>
        
        {/* Contact Link */}
        <Link 
          to="/contact" 
          className="inline-block bg-[#003a70] text-white px-6 py-3 rounded-lg hover:bg-[#003a70]/90 transition-colors font-medium"
        >
          Contact Us
        </Link>
      </DialogContent>
    </Dialog>
  );
};

export default SpecialOfferEndedModal;
